export default "__VITE_ASSET__B04aAwvT__"